import type { FC } from 'react';
import React, { memo } from 'react';

import { HeaderWrapper } from '@pages/networking/Network/components/NetworkNavigationPanelContainer/NetworkNavigationPanelContainer.styles';
import NetworkNavigationPanel from '@pages/networking/Network/components/network/components/NetworkNavigationPanel';
import { NetworkContactsAnalyticsEnum } from '@shared/analytics/network-contacts/network-contacts';
import { getNetworkAddItemsMenuConfig } from '@shared/configs/network/networkAddItemsMenu.config';
import { ModalNamesEnum } from '@shared/enums/modalNames.enum';
import { NetworkItemTypeEnum } from '@shared/enums/network/networkItemType.enum';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import modalObserver from '@shared/utils/observers/modalObserver';
import { setContactsFilters } from '@store/network/networkSlice';

import type { RenderNetworkAddItemMenuPropsType } from '@pages/networking/Network/components/network/functions/renderNetworkAddItemMenu';
import type { HubFiltersType } from '@shared/ui/popovers/HubFilterPopover/types';

const renderContactsMenu = ({
  t,
  theme,
  isMobileDisplay,
  gaEventTracker,
}: RenderNetworkAddItemMenuPropsType) => {
  const networkAddItemConfig = getNetworkAddItemsMenuConfig(t, theme, isMobileDisplay) as any;
  const openCreateContactModal = () => {
    gaEventTracker?.({
      event: NetworkContactsAnalyticsEnum.Contacts_Create_Selected,
    });
    modalObserver.addModal(ModalNamesEnum.createContactModal, {});
  };

  const openBusinessCardModal = () => {
    gaEventTracker?.({
      event: NetworkContactsAnalyticsEnum.Contacts_Scan_Business_Card_Selected,
    });
    modalObserver.addModal(ModalNamesEnum.scanBusinessCard, {});
  };

  return [
    {
      ...networkAddItemConfig[NetworkItemTypeEnum.contacts],
      label: 'Create contact',
      callback: openCreateContactModal,
    },
    {
      ...networkAddItemConfig[NetworkItemTypeEnum.scan_business],
      callback: openBusinessCardModal,
    },
  ];
};

const ContactsNavigationPanelContainer: FC = () => {
  const { contactsFilters } = useAppSelector(({ network }) => network.network);

  const dispatch = useAppDispatch();
  const setFilters = (inputValue: string, linking?: HubFiltersType, role?: string) => {
    dispatch(
      setContactsFilters({
        query: inputValue,
        role,
        linking,
      }),
    );
  };

  return (
    <HeaderWrapper>
      <NetworkNavigationPanel
        actionButtonConfig={{ menuList: renderContactsMenu }}
        setFilters={setFilters}
        isContact
        filters={contactsFilters}
      />
    </HeaderWrapper>
  );
};

export default memo(ContactsNavigationPanelContainer);
